<!-- Services Loader -->
<ng-container *ngIf="isLoading; else serviceCards">
  <app-fetching-data message="all-services.fetching-data"></app-fetching-data>
</ng-container>

<ng-template #serviceCards>
  <!-- Service cards section -->
  <ng-container
    *ngIf="filteredServices?.length; else noServicesFound"
    class="d-flex flex-wrap"
  >
    <!-- For testing purposes -->
    <!-- <h2 class="records">Record Count : {{ filteredServices.length }}</h2> -->

    <div class="row department-row" >
      <div
        class="col-6 col-sm-3 col-md-2 department-col"
        *ngFor="let service of filteredResult"
      >
        <app-service-card
          *ngIf="service?.depttype !== 'U'"
          [srvLogoUrl]="service.image"
          [serviceName]="service.serviceName"
          [displayName]="service.disname"
          [category]="service.categoryName"
          [categoryId]="service?.categoryId"
          [schemeId]="service.schemeId"
        ></app-service-card>
      </div>
    </div>
  </ng-container>

  <!-- No service found section -->
  <ng-template #noServicesFound>
    <app-no-data-found
      message="all-services.no-services-found"
    ></app-no-data-found>
  </ng-template>
</ng-template>
